import script from "./MyOrderOpenHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrderOpenHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrderOpenHeader.vue?vue&type=style&index=0&id=4266520a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4266520a"]])

export default __exports__